export default "__VITE_ASSET__BTsy1d1E__"